<script>
import PatientsListingFilters from '@components/PatientsMatrix/PatientsMatrixFilters'
import PatientsListingTableBody from '@components/PatientsMatrix/PatientsMatrixTableBody'

export default {
    components: {
        // eslint-disable-next-line vue/no-unused-components
        PatientsListingFilters,
        // eslint-disable-next-line vue/no-unused-components
        PatientsListingTableBody
    },
    props: {
        freemium: {
            type: Number,
            required: false,
            default: 0
        },
        freeze: {
            type: Number,
            required: false,
            default: 0
        },
        deactivated: {
            type: Number,
            required: false,
            default: 0
        },
        phase: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            patients: [],
            params: {},
            firstFetched: false
        }
    },
    created() {
        this.params = sessionStorage.getItem(this.sessionStorageKey) ? JSON.parse(sessionStorage.getItem(this.sessionStorageKey)) : {}
    },
    computed: {
        showDaysTillEndOfSubscription() {
            if(this.user.country === 'DE' && this.freeze === 0) {
                return true
            } else {
                return false
            }
        },
        sessionStorageKey() {
            return `${this.user.role}_${this.phase}_${this.freemium}_${this.freeze}_${this.deactivated}`
        }
    },
    methods: {
        onFetched(data) {
            this.firstFetched = true

            this.patients.push(...data)
        },
        onFilters(params) {
            this.params = params
            this.patients = []

            sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(this.params));

            this.$refs.TableBody.reset()
        },
        isEmpty() {
            return this.patients.length === 0
        }
    }
}
</script>
